export function AppFooter() {
  return (
    <p className="pb-6 pt-10 text-center text-xs text-ink-400">
      Erstellt von{" "}
      <a
        href="https://huebbedigital.com"
        target="_blank"
        rel="noreferrer"
        className="font-medium text-turf-700 underline-offset-2 hover:underline"
      >
        HuebbeDigital
      </a>
    </p>
  );
}
